<template>
	<div style=" width:100%; height:500px; ">
		<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">
			签约项目管理-解决方案
		</div>
		<el-button
			style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
			@click="Return">返回</el-button>
		<div style="margin: 0 5%; margin-top: 20px;">
			<el-row style="width: 100%; background-color: #FFFFFF; padding: 10px 20px;">
				<span style="display: inline-block; font-size: 20px; line-height: 27px; font-weight: 600;">
					解决方案A
				</span>
				<span style="background-color: #3bcdd1; color: #FFFFFF; font-size: 17px; 
				line-height: 27px; margin-left: 10px; display: inline-block; padding: 0 10px; 
				border-radius:5px; font-weight: normal;">
					100%符合客户要求
				</span>
				<div style="display: inline-block; float: right; font-weight: normal; font-size: 19px;">
					<span>总需人数：</span>50
					<span style="margin-left: 20px;">每日应出勤人数：</span>50
				</div>
			</el-row>
			<el-row style="width: 100%; background-color: #FFFFFF; margin-top: 5px; padding: 10px 20px;">
				<el-col :span="4" v-for="(item, index) in ruleForm.projectPostList" :key="index" style="margin-left: 1%; background-color: #fafafa; padding: 1% 0; padding-right: 10px;">
					<el-row>
						<el-col :span="2">
							<div style="display: inline-block; width: 10px; height: 15px; border-left: 3px #006E48 solid; margin-top: 4px;"></div>
						</el-col>
						<el-col :span="22" style="line-height: 24px; font-weight: bold; font-size: 17px;">
							岗位:{{item.post_name}}
							<hr />
						</el-col>
					</el-row>
					<el-row>
						<el-col :offset="2" :span="22">
							人数:&nbsp;&nbsp;{{item.person_count}}
						</el-col>
					</el-row>
					<el-row>
						<el-col :offset="2" :span="22">
							年龄:&nbsp;&nbsp;{{item.age_start}}-{{item.age_end}}
						</el-col>
					</el-row>
					<el-row>
						<el-col :offset="2" :span="22">
							性别:&nbsp;&nbsp;{{item.sex != '2' ? (item.sex == '0' ? '男' : '女') : '不限'}}
						</el-col>
					</el-row>
					<el-row>
						<el-col :offset="2" :span="5">
							班次:
						</el-col>
						<el-col :span="17">
							<el-row v-for="shift in item.shiftList" :key="shift.id">
								{{shift.shift}}: {{shift.start_time}}—{{shift.end_time}}
							</el-row>
						</el-col>
					</el-row>
					<el-row>
						<el-col :offset="2" :span="22">
							轮休方式:&nbsp;&nbsp;上{{item.holiday_start}}休{{item.holiday_end}}
						</el-col>
						
					</el-row>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["ruleForm"],
		data() {
			return {
				projectPostList: []
			}
		},
		methods: {
			//返回
			Return() {
				this.$parent.Return('add');
			}
		},
		async created() {
			this.projectPostList = this.$props["ruleForm"].projectPostList;
		}
	}
</script>

<style scoped="scoped">

</style>



// WEBPACK FOOTER //
// Jjfa_add.vue?38d8930e